import * as React from 'react';
import ArtworkViewContainer from 'containers/jinny/ArtworkViewContainer';

const View = () => {
  return <ArtworkViewContainer />;
};
export default View;
